// One requestAnimationFrame for all active instances. Offscreen/paused instances leave it.
const active = new Set();
let frame = 0;
function tick(now) {
  frame = 0;
  try {
    for (const instance of active) {
      try {
        instance.frame(now);
      } catch (error) {
        try {
          instance.fail(error);
        } catch (callbackError) {
          active.delete(instance);
          instance.callbackError = callbackError;
        }
      }
    }
  } finally {
    if (active.size && !frame) frame = requestAnimationFrame(tick);
  }
}
export function activate(instance) {
  active.add(instance);
  if (!frame) frame = requestAnimationFrame(tick);
}
export function deactivate(instance) {
  active.delete(instance);
  if (!active.size && frame) {
    cancelAnimationFrame(frame);
    frame = 0;
  }
}
